module.exports = __webpack_public_path__ + "img/inter19.835e6a90.jpg";